// Mirrors the header's Solutions/Industry group (navItems.data.ts) so the
// same curated set of industry pages is reachable from the footer too.
export const solutionsLinks = [
  { title: "Fashion & Apparel", href: "/loyalty-app-for-clothing-store" },
  { title: "Salons & Beauty", href: "/loyalty-software-for-salon" },
  { title: "Jewellery Shops", href: "/loyalty-program-for-jewellery-store" },
  { title: "Grocery Stores", href: "/loyalty-program-for-grocery-store" },
  { title: "Restaurants & Bars", href: "/customer-retention-for-restaurants" },
];
